import buildCsv from './buildCsv';
import { useAtomValue } from 'jotai';
import { exportDataAtom } from './atom';

function useExport({ config }) {
  const data = useAtomValue(exportDataAtom);

  const triggerDownload = () => {
    buildCsv({ config, data });
  };

  return { data, triggerDownload };
}

export default useExport;
